import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { useTheme } from '@mui/material/styles';

interface StudyTypeChartSeries {
  name: string;
  data: number[];
}

interface StudyTypeChartProps {
  categories: string[];
  series: StudyTypeChartSeries[];
}

const StudyTypeChart = ({ categories, series }: StudyTypeChartProps) => {
  const theme = useTheme();
  const seriesColors = [theme.palette.cardiac.teal, theme.palette.cardiac.amber];

  const options = {
    chart: {
      type: 'column',
      backgroundColor: 'transparent',
    },
    title: {
      text: null,
    },
    xAxis: {
      categories,
      labels: {
        style: {
          color: theme.palette.text.primary,
          fontSize: '12px',
        },
      },
      lineColor: theme.palette.divider,
    },
    yAxis: {
      title: {
        text: 'Number of Studies',
        style: {
          color: theme.palette.text.primary,
        },
      },
      labels: {
        style: {
          color: theme.palette.text.primary,
        },
      },
      allowDecimals: false,
      gridLineColor: theme.palette.divider,
    },
    plotOptions: {
      column: {
        grouping: true,
        borderWidth: 0,
      },
    },
    colors: seriesColors,
    series,
    legend: {
      enabled: true,
      itemStyle: {
        color: theme.palette.text.primary,
      },
    },
    credits: {
      enabled: false,
    },
  };

  return <HighchartsReact highcharts={Highcharts} options={options} />;
};

export default StudyTypeChart;
